export const integrations = {
  BookADemo: "Book a demo",
  LoadMore: "Load more",
  Connect: "Connect",
  Disconnect: "Disconnect",
  BackToIntegrations: "Back to integrations",
  GetStartedNow: "Get started now",
  ReactivateIntegration: "Reactivate integration",
  Integration: "Integration",
  Integrations: "Integrations",
  IntegrationHeader:
    "Integrate Fullscript with your favorite electronic health record platforms and practice management software! You can easily dispense professional-grade supplements to your {{patientTermPlural}} without leaving your EHR platform. Choose from the library of integrations, connect your favorite EHR, or discover a new tool.",
  LookingForAnIntegrationTrans:
    "Don't see what you're looking for? <2>Request a specific integration.</2>",
  LookingForAnIntegrationEmailTo: "integration.requests@fullscript.com",
  LookingForAnIntegrationEmailSubject: "Fullscript Integration Request Form",
  LookingForAnIntegrationEmailBody:
    "Thank you for taking the time to make this request. Please fill out this information so we can showcase the value of your desired integration: %0D%0A%0D%0A" +
    "Email address associated with your Fullscript account. If you do not have an account, please enter 'no account': %0D%0A" +
    "First Name: %0D%0A" +
    "Last Name: %0D%0A" +
    "Name of the integration(s): %0D%0A" +
    "Number Of Patients (the number of patients you support): %0D%0A" +
    "Anything else you'd like us to know: %0D%0A%0D%0A" +
    "Healthy regards,%0D%0A" +
    "Fullscript API Support",
  Categories: "Categories",
  RecommendedFor: "Recommended for",
  FullscriptIsAvailableOn: "Fullscript is available on:",
  Sort: "Sort",
  RecentlyAdded: "Recently added",
  AlphabeticalAZ: "A-Z",
  AlphabeticalZA: "Z-A",
  LearnMore: "Learn more",
  LookingForASpecificIntegration: "Looking for a specific integration?",
  SendARequest: "Send a request",
  By: "By",
  About: "About",
  KeyFeatures: "Key features",
  HowToIntegrateWithFullscript: "How to integrate with Fullscript",
  Connected: "Connected",
  Preview: "Preview",
  ClickOnImageToEnlarge: "(click on image to enlarge)",
  NeedHelp: "Need help?",
  BookAFreeDemo: "<0>Book a free demo</0> to learn more about Fullscript and {{IntegrationName}}.",
  OrYouCanGetInTouch:
    "Or, you can get in touch with us by sending an email to <1>integrations@fullscript.com</1>",
  VideoPreview: "{{IntegrationName}} video preview",
  WatchFullscriptComeToLife: "Watch Fullscript come to life in the {{IntegrationName}} platform",
  SuccessDisconnect: "{{name}} successfully disconnected",
  SuccessConnect: "{{name}} successfully connected",
  ErrorDisconnect: "There was an error when trying to disconnect {{name}}. Please try again.",
  NotEstablishConnection: "Connection not established",
  FailureMessage:
    "We were unable to detect a connection with {{integrationName}}. Please refresh the page or try again.",
  DisconnectWithIntegrationName: "Disconnect with {{integrationName}}",
  AreYouSureDisconnect:
    "Are you sure you want to disconnect your {{integrationName}} integration with your Fullscript store? This action will also disconnect the integration for all practitioners in the dispensary who are actively connected.",
  YesDisconnect: "Yes, disconnect.",
  NoDontDisconnect: "No, don't disconnect.",
  RecommendFromEHR: "Recommend from your EHR",
  SelectPlatform:
    "Dispense professional-grade supplements to your {{patientTermPlural}} without leaving your electronic health record (EHR) platform. Select your favorite EHR platform and get started today.",
  ViewIntegrations: "View integrations",
  OnlyStoreOwnersCanChangeIntegrations: "Only clinic owners can change integration settings.",
  IntegrationWindowOpen: "Finish integration connection in the opened window to continue.",
  AC: {
    title: "Get started with Elation",
    reactivationTitle: "Reactivate Elation",
    caution:
      "<bold>You need an existing Elation account to connect with Fullscript.</bold> If you don't have one, <Link>book a demo with Elation here.</Link>",
    estimationPeriod: "Please allow 3-5 days for our team to process your request.",
    reactivationEstimationPeriod:
      "Please allow 2-5 days for our team to process your reactivation request.",
    elationPracticeName: "Elation practice name",
    elationPracticeNameDescription: "If unknown, <Link>refer to this guide article.</Link>",
    bestContactNumber: "Best contact number",
    bestContactNumberDescription: "Must be between 8 and 15 digits",
    numberOfProviders: "Number of providers in your practice",
    numberOfPatietns: "Number of patients",
    dataAccessAcknowledgmentCheckbox:
      "By enabling this integration, I acknowledge and understand that Fullscript will retrieve the following patient information from Elation: name, email, mobile number, and date of birth (DOB). Additionally, Fullscript will provide details about my treatment plans back to Elation upon sending.",
    inputAuthenticityAndElationIntegrationAcknowledgmentCheckbox:
      "I acknowledge the above information to be true and hereby consent to enable Fullscript's integration with Elation.",
    successMessage: "Successfully sent request",
    proccessingRequestTooltipWithDate:
      "We're currently processing your request sent on {{sentDate}}.",
    proccessingRequestTooltip: "We're currently processing your request.",
  },
  linkStatus: "Link status",
  linkPatient: "Link {{patientTerm}}",
  relinkPatient: "Relink {{patientTerm}}",
  unlinked: "Unlinked",
  linked: "Linked",
  Jane: {
    modal: {
      title: "Connect to Jane",
      description: "Connect your Jane account by entering your clinic URL.",
      clinicUrlLabel: "Jane Clinic URL",
      clinicUrlPlaceholder: "https://your-clinic.jane.app",
      clinicUrlDescription:
        "Enter the full URL of your Jane clinic (e.g., https://myclinic.jane.app)",
      validationError: "Please enter a valid clinic URL",
      saveError: "Failed to save clinic URL. Please try again.",
    },
  },
  patientLinking: {
    confirmLinkHeader: "Confirm {{patientTerm}} link",
    confirmRelinkHeader: "Confirm {{patientTerm}} relink",
    willLinkPatient:
      "The Fullscript {{patientTerm}} <bold>{{patientName}}</bold> will be linked to <bold>{{integrationName}}</bold>",
    willRelinkPatient:
      "This will override Fullscript patient <bold>{{patientName}}'s</bold> current link",
    futureplans: "Future plans sent to this {{patientTerm}} on FS will reflect in EHR",
    changeLink: "This link can be changed from the {{patientTerm}} panel on FS",
    confirmLink: "Confirm link",
    selectPatientLink: "Select {{patientTerm}} link",
    returnToPractitionerSelect: "Back to practitioner selection",
    writtingOnBehalf: "Writting on behalf of <bold>{{practitionerName}}</bold>",
  },
  backToPatientSelection: "Back to {{patientTerm}} selection",
  practitionerSelectInstructions:
    "Choose a practitioner to write on behalf of. To create a new practitioner, add them in the <l>Fullscript web application</l>.",
  CreateAndLinkPatient: "Create and link {{patientTerm}}",
  CartOpenNewWindow: "Cart will open in a new window",
  SelectPractitioner: "Select practitioner",
} as const;
